import { useQuery } from '@tanstack/react-query'
import { getSubscriptions, getExpiringSoon } from '@/lib/api/admin/subscriptions'
import type { SubscriptionStatus, SubscriptionPlan } from '@/types/admin'

/**
 * Hook to fetch paginated subscription list
 */
export function useSubscriptions(params: {
  page?: number
  size?: number
  status?: SubscriptionStatus
  plan?: SubscriptionPlan
  restaurantName?: string
}) {
  return useQuery({
    queryKey: ['admin', 'subscriptions', params],
    queryFn: () => getSubscriptions(params),
  })
}

/**
 * Hook to fetch subscriptions expiring soon
 */
export function useExpiringSoon() {
  return useQuery({
    queryKey: ['admin', 'subscriptions', 'expiring-soon'],
    queryFn: getExpiringSoon,
    refetchInterval: 60000, // Refresh every minute
  })
}
